import setNotificationSettingsService from 'owa-service/lib/operation/setNotificationSettingsOperation';
import NewNotification from 'owa-service/lib/contract/NewNotification';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import notificationSettingsRequest from 'owa-service/lib/factory/notificationSettingsRequest';

export default function setNotificationSettings(
    newMailSettings: NewNotification,
    enableReminders: boolean,
    enableReminderSound: boolean
) {
    return setNotificationSettingsService({
        Header: getJsonRequestHeader(),
        Body: notificationSettingsRequest({
            NewItemNotify: newMailSettings,
            EnableReminders: enableReminders,
            EnableReminderSound: enableReminderSound,
        }),
    });
}
